import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=e5a46bba&scoped=true&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCard.vue?vue&type=style&index=0&id=e5a46bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a46bba",
  null
  
)

export default component.exports